// ============================================================
// FNV-1a 32bit
// ============================================================
// updateImageRawData の前に diff スキップ判定するための高速ハッシュ。
// 衝突確率は実用上問題なし (画像 10KB に対して 2^32 空間)。

export function hash32(buf: Uint8Array): number {
  let h = 0x811c9dc5
  for (let i = 0; i < buf.length; i++) {
    h ^= buf[i]
    h = Math.imul(h, 0x01000193)
  }
  return h >>> 0
}
